import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { BxBaseTemplateComponent } from 'app/layout/components-common/section-base-template/section-base-template.component';

@NgModule({
    declarations: [
        BxBaseTemplateComponent
    ],
    imports: [
        MatIconModule,        
        CommonModule
    ],
    exports     : [
        BxBaseTemplateComponent
    ]})
export class BxBaseTemplateModule
{
}
